<template>
  <div class="agreement">
    <div class="agreement_nei">
      <div class="left">
        <leftTemplate5 @back="back"></leftTemplate5>
      </div>
      <div class="right">
        <el-table
          ref="multipleTableRef"
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          height="500"
        >
          <el-table-column property="name" width="250" label="器材名称" />
          <el-table-column
            property="createTime"
            label="发布时间"
            align="center"
          >
            <template #default="scope">
              <!-- {{ dateFormat(scope.row.createTime) }} -->
              {{ com_date.com_date.timestamp_string(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column
            property="contactInformation"
            label="联系方式"
            align="center"
          />
          <el-table-column label="操作" width="210" align="center">
            <template #default="scope">
              <div style="display: flex; align-items: center">
                <div
                  @click="showReleaseLease(scope.row)"
                  style="width: 100px"
                  class="topBtn"
                >
                  修改
                </div>
                <div
                  @click="handleDel(scope.row)"
                  style="color: #ff2929; margin-left: 0.3rem; cursor: pointer"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
          <template #empty>
            <div style="height: 550px" v-if="tableData.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img
                  style="width: 100%; margin: 0 auto"
                  src="../../assets/zt_404.png"
                />
              </div>
            </div>
          </template>
        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: center">
          <el-pagination
            v-if="tableData.length != 0"
            v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="margin: 0.4rem 0"
            background
            layout="prev, pager, next"
            :total="page.total"
          />
        </div>
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog title="" v-model="dialogDelVisible" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img
          style="100%;height: 100%;"
          src="@/assets/img/tips／exclamation-circle-fill@2x.png"
        />
      </div>
      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        是否确认删除此租赁需求？
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="delSubmit">确认</div>
      </div>
    </el-dialog>
    <el-dialog
      style="margin-top: 0.3rem"
      title="发布租赁需求"
      v-model="checked"
      align-center
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="800px"
    >
      <el-form :model="form" label-width="100px" ref="formRef" :rules="rules">
        <el-form-item label="封面" prop="url">
          <el-upload
            v-if="fileList.length == 0"
            class="upload-demo"
            :action="upload_action"
            :on-change="handleChange"
            :on-progress="onProgress"
            :on-success="onSuccess"
            :on-remove="handleRemove"
            :show-file-list="false"
            ref="upload"
            :file-list="fileList"
            :limit="1"
            drag
          >
            <!--  :action="serverBaseUrl + '/dev-api/file/upload'"
            :headers="header" -->
            <el-icon class="el-icon--upload">
              <div
                style="
                  width: 0.2rem;
                  height: 0.2rem;
                  background: url(data:image/png;base64,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);
                  background-size: 100%;
                  background-repeat: no-repeat;
                "
              ></div>
            </el-icon>
            <div class="el-upload__text">
              <div style="font-size: 0.14rem; color: #333333">
                点击或拖拽文件到此处上传
              </div>
              <div style="font-size: 0.12rem; color: #86909c">
                图片比例建议1:1
              </div>
            </div>
          </el-upload>
          <div
            v-if="fileList.length"
            style="
              background: #ccc;
              text-align: center;
              width: 150px;
              height: 150px;
            "
          >
            <el-image
              style="width: 150px; height: 150px"
              fit="fit"
              :src="fileList[0].url"
              :preview-src-list="[fileList[0].url]"
            >
            </el-image>
            <!-- <div class="img-text">
              {{
                fileList[0].name1.match(regex)[1] +
                "" +
                fileList[0].name1.match(regex)[2]
              }}
            </div> -->
            <el-image
              :src="url"
              @click="handleRemove(fileList[0].url)"
              class="img-Off"
            />
          </div>
        </el-form-item>
        <el-form-item label="器材细节" prop="url1">
          <div style="display: flex" class="he">
            <div v-for="(item, index) in fileList1" :key="index" class="he1">
              <el-image
                class="img"
                v-if="index == 0"
                :src="item.url"
                style=""
                :key="index"
                :preview-src-list="fileList1.map((e) => e.url)"
                fit="cover"
                :initial-index="index"
              />
              <div class="he2">
                <el-image
                  class="img"
                  v-if="index != 0"
                  :src="item.url"
                  style=""
                  :key="index"
                  :preview-src-list="fileList1.map((e) => e.url)"
                  fit="cover"
                  :initial-index="index"
                />
                <el-image
                  :key="index"
                  v-if="index != 0"
                  :src="url"
                  @click="handleRemove2(index)"
                  class="img-Off1"
                />
              </div>
              <el-image
                :key="index"
                v-if="index == 0"
                :src="url"
                @click="handleRemove2(index)"
                class="img-Off1"
              />
            </div>
            <div
              class="img_he1"
              v-for="index in 6 - fileList1.length"
              :style="
                fileList1.length == 0
                  ? index !== 1
                    ? 'margin-left: 20px'
                    : ''
                  : 'margin-left: 20px'
              "
              :key="index"
              @click="() => uploadImage(index)"
            >
              <el-icon><Plus /></el-icon>
              <input
                type="file"
                :ref="setFileInputRef(index)"
                @change="handleFileChange"
                style="display: none"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="器材名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入器材名称" />
        </el-form-item>
        <el-form-item label="配置说明" prop="description">
          <el-input
            type="textarea"
            v-model="form.description"
            placeholder="请填写配置说明"
          />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInformation">
          <el-input
            v-model="form.contactInformation"
            placeholder="请填写手机号/邮箱等联系方式"
          />
        </el-form-item>
      </el-form>
      <div style="color: #86909c; margin-left: 0.2rem">
        请填写器材设备相关信息，切勿发布不实信息或违法信息
      </div>
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <div class="dataBtn dataBtnQx" @click="handleClose(false)">取消</div>
        <div class="dataBtn" @click="submitForm()">确认发布</div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import com_date from "@/assets/js/common.js";
import { ref, reactive } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import type { FormRules } from "element-plus";
import { ElMessage, ElLoading } from "element-plus";
import leftTemplate5 from "@/components/leftTemplate5.vue";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import url from "@/assets/module_share_open.png";
const upload_action = ref(serverBaseUrl + "/file/upload");
const ccc = ref("");
document.title = "标识山西-器材管理";
const tableData = ref([{}]);
let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const regex = /(.+)_.*(\..+)/;
// 发布
const form = ref<Form>({
  contactInformation: "",
  coverSheet: "",
  name: null,
  url: "",
  description: "",
  url1: [],
});
type Form = {
  contactInformation: string;
  coverSheet: string;
  name: string;
  description: string;
};
let dialogDelVisible = ref(false);
const idArray = ref([]);
const page = pageDef;
const upload = ref<any>();
const upload1 = ref<any>();
const fileList = ref([]);
const fileList1 = ref([]);
const formRef = ref<any>();
let loading = ref(false);
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
}
const allowedExtensions = [".png", ".jpg", ".jpeg"];
const multipleSelection = ref<User[]>([]);
type Rules = {
  [K in keyof Form]?: Array<FormItemRule>;
};
const rules = reactive<FormRules<Rules>>({
  contactInformation: [
    { required: true, message: "请输入联系方式", trigger: "change" },
  ],
  coverSheet: [{ required: true, message: "请输入封面", trigger: "change" }],
  name: [{ required: true, message: "请输入名称", trigger: "change" }],
  description: [
    { required: true, message: "请输入描述说明", trigger: "change" },
  ],
  url: [{ required: true, message: "请上传传封面", trigger: "change" }],
  url1: [{ required: true, message: "请上传器材细节", trigger: "change" }],
});
const back = (val) => {
  console.log(val);
  ccc.value = val;
};
const handleSelectionChange = (val: User[]) => {
  console.log(value, "这里是");
  multipleSelection.value = val;
};
const handleDel = (row) => {
  idArray.value = [row.id];
  dialogDelVisible.value = true;
};
const sizeChange = (val) => {
  init();
};
const currentChange = (val) => {
  init();
};
const init = () => {
  Axios(
    "POST",
    "/material/material/equipment/list",
    {
      pageIndex: pageDef.value.pageNum,
      pageSize: pageDef.value.pageSize,
      condition: {
        userId: JSON.parse(localStorage.getItem("userList")).memberId,
      },
    },
    false,
    (res) => {
      if (res.data.code == 200) {
        tableData.value = res.data.data.records;
        pageDef.value.total = res.data.data.total;
      } else {
        ElMessage({
          message: res.data.msg,
          type: "error",
        });
      }
    }
  );
};
init();
const delSubmit = () => {
  Axios(
    "post",
    `/material/material/equipment/del`,
    idArray.value,
    false,
    (res) => {
      if (res.data.code == 200) {
        dialogDelVisible.value = false;
        // 要删除的索引数组
        // isTableLoading.value = false;
        init();
        ElMessage.success("删除成功");
      } else {
        ElMessage.warning("删除错误");
      }
    }
  );
};
const dateFormat = (val: number) => {
  const date = new Date(val);
  const year = date.getFullYear();
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  const minutes = date.getMinutes();
  const seconds =
    date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const checked = ref(false);
const showReleaseLease = function (data) {
  Axios("get", `/material/material/equipment/${data.id}`, {}, false, (res) => {
    if (res.data.code == 200) {
      fileList1.value = [];
      fileList.value = [];
      res.data.data.info.url1 = [];
      res.data.data.info.url = [];

      res.data.data.imgs.forEach((e) => {
        if (e.isCoverSheet == 1) {
          fileList1.value.push({
            name: e.url,
            name1: e.url.split("?")[0],
            url: e.url,
            size: 32111,
          });
          res.data.data.info.url1.push(e.url);
        } else {
          fileList.value.push({
            name: e.url,
            url: e.url,
            name1: e.url.split("?")[0],

            size: 32111,
          });
          res.data.data.info.url.push(e.url);
        }
      });
      form.value = res.data.data.info;
    } else {
      ElMessage({
        message: res.data.msg,
        type: "error",
      });
    }
  });
  checked.value = true;
};
const openWindow = function () {
  checked.value = false;
};
//关闭
const handleClose = function (e) {
  form.value = {
    contactInformation: "",
    coverSheet: "",
    name: null,
    description: "",
  };
  fileList.value = [];
  fileList1.value = [];
  checked.value = false;
  formRef.value.resetFields();
};
// 提交
const submitForm = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let obj = { ...form.value };
      if (fileList.value.length == 0) {
        return ElMessage.warning("请上传封面");
      }
      if (fileList1.value.length == 0) {
        return ElMessage.warning("器材细节");
      }
      obj.coverSheet = fileList.value[0].url;
      // obj.type = fileList.value[0].name.substring(
      // fileList.value[0].name.lastIndexOf(".") + 1
      // );
      // let fileList1S = [...];
      let fileList1S = JSON.parse(JSON.stringify(fileList1.value));
      fileList1S.push(fileList.value[0]);
      obj.imgs = fileList1S.map((e) => {
        // 0 是封面 1不是
        return {
          url: e.url,
          isCoverSheet: 1,
          type: e.url.substring(e.url.lastIndexOf(".") + 1, e.url.indexOf("?")),
        };
      });
      obj.imgs[obj.imgs.length - 1].isCoverSheet = 0;
      Axios(
        "POST",
        "/material/material/equipment/sou",
        obj,
        false,
        function (res) {
          if (res.data.code == 200) {
            handleClose(true);
          } else {
            ElMessage.error(res.data.message);
          }
        }
      );
      // obj.imgs = list.value;
      // console.log(obj);
    } else {
      return false;
    }
  });
};
const onProgress = () => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
};
const fileInputs = ref([]);
const setFileInputRef = (index) => {
  return (el) => {
    fileInputs.value[index] = el;
  };
};
const uploadImage = (index) => {
  // fileInput.value.click();
  if (fileInputs.value[index]) {
    fileInputs.value[index].click();
  }
  // console.log(fileInputs.value[index]);
  // console.log(fileInput.value);
};

const handleFileChange = (event: any) => {
  const file = event.target.files[0];
  if (!file) return;

  // Checking the file extension
  const fileExtension = file.name.split(".").pop().toLowerCase();
  if (!allowedExtensions.includes("." + fileExtension)) {
    return ElMessage.warning("格式不正确");
  }
  // console.log(file);
  handleFileChange1(file);
  // Reset the input after handling the file
  event.target.value = null;
};
const handleRemove2 = (index) => {
  console.log(index);

  fileList1.value.splice(index, 1);
};
const handleFileChange1 = (file) => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  const formData = new FormData();
  formData.append("file", file);
  Axios(
    "POST",
    "/file/upload",
    formData,
    false,
    function (res) {
      if (res.data.code == 200) {
        // handleClose(true);
        fileList1.value.push({
          url: res.data.data.url,
          name: res.data.data.url,
        });
        form.value.url1.push({ url: res.data.url });
        loading.value.close();
      } else {
        ElMessage.error(res.data.message);
      }
    },
    false,
    1
  );
};
const dialogVisible = ref(false);
const dialogImageUrl = ref("");
const uploadImage1 = (index: any) => {
  dialogVisible.value = true;
  dialogImageUrl.value = fileList1.value[index].url;
};
// 上传前
const handleChange = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    upload.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
};
const handleExceed = (files: any, fileList1: any) => {
  return ElMessage.warning("最多上传六个图片");
};
// 上传成功
const onSuccess = (res: any, file: any, fileList1: any) => {
  fileList.value.push({
    url: res.data.url,
    name: res.data.name,
    name1: res.data.name.split("?")[0],
  });
  form.value.url = res.data.url;
  // console.log("loading.value", loading.value).;

  // loading.value.close();
  loading.value.close();
  console.log(fileList.value);
};
// // 删除图片
const handleRemove = (file, fileList1, type) => {
  fileList.value.splice(
    fileList.value.findIndex((item) => item.url === file.url),
    1
  );
  form.value.url = null;
};
// 上传1
const handleChange1 = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    upload1.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
};
// 上传成功1
const onSuccess1 = (res: any, file: any, fileList: any) => {
  fileList1.value.push({
    url: res.data.url,
    name: res.data.url,
  });
  loading.value.close();
  form.value.url1.push({ url: res.data.url });
};
// // 删除图片1
const handleRemove1 = (file, type) => {
  try {
    fileList1.value.splice(
      fileList1.value.findIndex((item) => item.url === file.url),
      1
    );
  } catch (e) {
    console.log(e);
  }
  try {
    form.value.url1.splice(
      fileList1.value.findIndex((item) => item.url === file.url),
      1
    );
  } catch (e) {
    console.log(e);
  }
};
</script>

<style lang="less" scoped>
.agreement {
  background-color: #f5f5f5;
}

.agreement_nei {
  width: 12.8rem;
  margin: 0 auto;
  margin-top: 0.7rem;
  display: flex;
  justify-content: center;
}

.left {
  flex: none;
  width: 1.6rem;
  background: #fff;
  margin-right: 0.4rem;
  min-height: 5.83rem;
  margin-top: 0.3rem;
  margin-bottom: 0.24rem;
  border-radius: 0.18rem;
  min-width: 1.6rem;
  box-sizing: border-box;
}

.right {
  flex: none;
  width: calc(100% - 1.6rem);
  min-width: 10.8rem;
  background: #fff;
  min-height: 5.83rem;
  margin-top: 0.3rem;
  margin-bottom: 0.24rem;
  border-radius: 0.18rem;
  overflow: hidden;
}

.topBtn {
  width: 0.8rem;
  height: 0.33rem;
  line-height: 0.33rem;
  background: #C01A26;
  font-size: 0.14rem;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  border-radius: 0.04rem;
  opacity: 1;
  border: none;
}

.dataBtn {
  width: 0.88rem;
  padding: 0.08rem 0.16rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
}

.dataBtnQx {
  margin-right: 0.2rem;
  border: 1px solid #86909c;
  color: #333333;
  background: transparent;
}
.img-Off {
  position: absolute;
  left: 120px;
  top: -10px;
  width: 40px;
  height: 40px;
}
.img-Off1 {
  position: absolute;
  left: 0.5rem;
  top: -10px;
  width: 40px;
  height: 40px;
  z-index: 5;
}
/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}
/deep/.el-upload-dragger {
  border: 0;
}
/deep/ input[type="file"] {
  display: none;
}

/deep/ .el-upload__input {
  display: none;
}
/deep/ .el-upload-dragger {
  background: #f5f5f5;
  width: 2rem;
  height: 2rem;
}
.he {
  // margin-left: 10px;

  .he1 {
    position: relative;
    .he2 {
      position: relative;
      /deep/ .el-image__inner {
        height: 100%;
        width: 100%;
      }
      .el-image {
        margin-left: 20px;
      }
    }
    /deep/ .el-image__inner {
      // height: 100%;
      // width: 92%;
    }

    .img {
      width: 0.8rem;
      height: 0.8rem;
    }
  }

  // .img1 {
  //   width: 0.8rem;
  //   height: 0.8rem;
  // }
}
.img_he1 {
  height: 0.8rem;
  width: 0.8rem;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
